/**
 * Display-only relabels for the Non-US CRE dashboard (mapping spec, API layer — not Snowflake DDL).
 * Filter / chart identity keys stay as tape values (`ReadyCap - Origin`, `Social Care`, …).
 */

const CRE_DEAL_DISPLAY_BY_TAPE_NAME: Readonly<Record<string, string>> = {
  'ReadyCap - Origin': 'ReadyCap',
  'Sunshine (Solaris II)': 'Sunshine',
};

/** Tape `DEAL_NAME` for ReadyCap — WA LTV is computed on this facility only. */
export const NON_US_CRE_READYCAP_DEAL_NAME = 'ReadyCap - Origin';

const CRE_PROPERTY_TYPE_DISPLAY_BY_TAPE_NAME: Readonly<Record<string, string>> = {
  'Social Care': 'Care',
  'Senior Housing': 'Elderly Care',
  Education: 'School',
  'Mixed / Residential': 'Mixed/Residential',
};

/** Facility filter / legend label (tape `DEAL_NAME` → spec short name). */
export function formatNonUsCreDealDisplayName(tapeDealName: string): string {
  const trimmed = tapeDealName.trim();
  return CRE_DEAL_DISPLAY_BY_TAPE_NAME[trimmed] ?? trimmed;
}

/** Property-type filter / legend label. */
export function formatNonUsCrePropertyTypeDisplayName(tapePropertyType: string): string {
  const trimmed = tapePropertyType.trim();
  return CRE_PROPERTY_TYPE_DISPLAY_BY_TAPE_NAME[trimmed] ?? trimmed;
}

export function nonUsCreDealNamesToOptions(values: readonly string[]): { id: string; label: string }[] {
  return values.map(v => ({
    id: v,
    label: formatNonUsCreDealDisplayName(v),
  }));
}

export function nonUsCrePropertyTypesToOptions(values: readonly string[]): { id: string; label: string }[] {
  return values.map(v => ({
    id: v,
    label: formatNonUsCrePropertyTypeDisplayName(v),
  }));
}
